import cadTiposReducer from './reducers';

export { default as cadTiposTypes } from './types';
export { default as cadTiposActions } from './actions';
export { default as cadTiposSagas } from './sagas';

export default cadTiposReducer;
